import { useMutation } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';

export function useUpdateInsurance({ token = '' }) {
  const mutation = useMutation({
    mutationKey: ['update-insurance', token],
    mutationFn: async (params = {}) => {
      const data = await handleFetchResponse(
        fetch(
          getApiUrl(
            params.add
              ? 'energia-solar/v2/simulation/add-insurance'
              : 'energia-solar/v2/simulation/remove-insurance',
          ),
          {
            method: 'PUT',
            body: JSON.stringify(params),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
        ),
      );
      return data;
    },
  });

  return mutation;
}
